import { type UseQueryResult, useQuery } from "@tanstack/react-query";

import { backendService } from "../../services/backend.service";
import type { JobDepartmentSubRole } from "../../utils/models";

export function useGetDepartmentSubRoles(departmentId: string | undefined): UseQueryResult<JobDepartmentSubRole[], Error> {
	return useQuery<JobDepartmentSubRole[], Error>({
		queryKey: ["useGetDepartmentSubRoles", departmentId],
		queryFn: async () => {
			if (!departmentId) return [];
			const response = await backendService.getDepartmentSubRoles(departmentId);
			return response.data;
		},
		enabled: !!departmentId,
		staleTime: 5 * 60 * 1000,
	});
}
